import { slices } from "@/constants/sliceNames";
import {
  requestRolesListStatus,
  requestCreateRoleStatus,
  requestPermissionsListStatus,
  requestDeleteRoleStatus,
} from "@/store/effects/admin-dashboard/roles-effects";
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  items: [],
  loading: false,
  error: null,
  permissions: [],
  _permissions: {},
};

const rolesSlice = createSlice({
  name: slices.roles,
  initialState,
  extraReducers: {
    ...requestRolesListStatus,
    ...requestCreateRoleStatus,
    ...requestPermissionsListStatus,
    ...requestDeleteRoleStatus,
  },
});

const { actions, reducer } = rolesSlice;

export { actions, initialState };

export default reducer;
